// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface SendActiveRequestPayload {
  duration: number;
  organizationId: number | null;
  sourceFrom: string;
  sourceId: number;
  vodId: number;
}

export interface SendActiveSuccessPayload {}

export interface SendActiveFailPayload {
  error: Error;
}

export const sendActiveActions = createAsyncAction(
  'elearning/SEND_ACTIVE',
  'elearning/SEND_ACTIVE_SUCCESS',
  'elearning/SEND_ACTIVE_FAIL'
)<
  SendActiveRequestPayload,
  SendActiveSuccessPayload,
  SendActiveFailPayload
>();
